class ContactList {
    constructor() {
        this.length = 0;
        this.remainder = 0; // Number of promokits stored beyond the latest_promokits_limit
        this.latest_promokits = {};
        this.temp_promokits = {};
        this.promokits = [];
        this.updateCallbacks = [];
        this.addPromokitCallbacks = [];
        this.removePromokitCallbacks = [];
        this.defaults = {
            cookie_latest_promokits: 'favorites_latest_promokits', // Cookie name for the shorter list object
            cookie_promokits: 'favorites_promokits', // Cookie name for the ordered array
            cookie_options: {
                expires: 604800, // 7 days in seconds
            },
            latest_promokits_limit: 5, // Specify the amount to show in the favorites dropdown
            promokits_limit: 30, // Limit the full list to only 30 promokits
        };
    }

    init() {
        // Fetch data from cookies
        const latest_promokits_cookie_data = Cookies.get(this.defaults.cookie_latest_promokits);
        const promokits_cookie_data = Cookies.get(this.defaults.cookie_promokits);

        if (latest_promokits_cookie_data && promokits_cookie_data) {
            try {
                this.latest_promokits = JSON.parse(latest_promokits_cookie_data) || {};
                this.temp_promokits = JSON.parse(latest_promokits_cookie_data) || {};
                this.promokits = JSON.parse(promokits_cookie_data) || [];
            } catch (e) {
                console.error('Error parsing cookie data:', e);
                this.latest_promokits = {};
                this.temp_promokits = {};
                this.promokits = [];
            }
        }

        // Add any promokits not in latest_promokits_data to temp_promokits
        if (typeof GS !== 'undefined' && typeof GS.temp_promokits !== 'undefined') {
            const all_saved_promokits = JSON.parse(GS.temp_promokits);
            Object.keys(all_saved_promokits).forEach((identifier) => {
                if (!this.temp_promokits.hasOwnProperty(identifier)) {
                    this.temp_promokits[identifier] = all_saved_promokits[identifier];
                }
            });
        }

        this.update({ type: 'init' });
    }

    getNthPromokit(n) {
        // Ensure we have a promokit at the specified position
        if (typeof n !== 'number' || n <= 0 || n > this.promokits.length) {
            return false;
        }

        // Get the PromoKit at index n - 1 since arrays are zero-indexed
        const identifier = this.promokits[n - 1];

        return { promokit_identifier: identifier, promokit: this.temp_promokits[identifier] };
    }

    maintainBounds() {
        // Truncate the latest_promokits if over the limit
        if (this.remainder > 0) {
            Object.keys(this.latest_promokits).forEach((identifier) => {
                if (this.promokits.indexOf(identifier) >= this.defaults.latest_promokits_limit) {
                    delete this.latest_promokits[identifier];
                }
            });
        }

        // Truncate the complete list if over its limit
        if (this.promokits.length > this.defaults.promokits_limit) {
            this.promokits.length = this.defaults.promokits_limit;
        }

        // Add missing promokits to latest_promokits until the limit is reached
        const count_latest_promokits = Object.keys(this.latest_promokits).length;
        const underage = this.defaults.latest_promokits_limit - count_latest_promokits;

        if (underage > 0 && this.length > count_latest_promokits) {
            for (let i = 0; i < Math.min(this.defaults.latest_promokits_limit, this.promokits.length); i++) {
                const identifier = this.promokits[i];

                if (!this.latest_promokits.hasOwnProperty(identifier)) {
                    if (this.temp_promokits.hasOwnProperty(identifier)) {
                        this.latest_promokits[identifier] = this.temp_promokits[identifier];
                    } else {
                        // Fetch data if not available in temp_promokits
                        const validIdentifier = encodeURIComponent(identifier);
                        const json_uri = `/ajax/get_favorite_promokit/${validIdentifier}`;

                        fetch(json_uri)
                            .then((response) => response.json())
                            .then((data) => {
                                if (data) {
                                    this.latest_promokits[identifier] = data;
                                    this.update({ type: 'countChanged' });
                                }
                            })
                            .catch((error) => {
                                console.error('Error fetching promokit data:', error);
                            });
                    }
                }
            }
        }
    }

    /*
		BUG: When you open promokits in multiple tabs and favorite each one without refreshing the page, the favorites list will not update properly.
	*/
    addPromokit(identifier, promokit) {
        if (typeof identifier !== 'string') {
            return false;
        }

        // Prevent duplicates
        if (this.promokits.indexOf(identifier) !== -1) {
            return false;
        }

        if (typeof promokit === 'object') {
            this.promokits.unshift(identifier);
            this.latest_promokits[identifier] = promokit;
            this.temp_promokits[identifier] = promokit;
            this.update({ type: 'addPromokit', promokit_identifier: identifier, promokit });
        } else if (this.temp_promokits.hasOwnProperty(identifier)) {
            this.promokits.unshift(identifier);
            this.latest_promokits[identifier] = this.temp_promokits[identifier];
            this.update({ type: 'addPromokit', promokit_identifier: identifier, promokit: this.temp_promokits[identifier] });
        } else {
            // Fetch the PromoKit data
            const validIdentifier = encodeURIComponent(identifier);
            const json_uri = `/ajax/get_favorite_promokit/${validIdentifier}`;

            fetch(json_uri)
                .then((response) => response.json())
                .then((data) => {
                    if (data) {
                        this.promokits.unshift(identifier);
                        this.latest_promokits[identifier] = data;
                        this.temp_promokits[identifier] = data;
                        this.update({ type: 'addPromokit', promokit_identifier: identifier, promokit: data });
                    }
                })
                .catch((error) => {
                    console.error('Error adding promokit:', error);
                });
        }
    }

    removePromokit(identifier) {
        // Remove from latest_promokits
        if (this.latest_promokits.hasOwnProperty(identifier)) {
            delete this.latest_promokits[identifier];
        }

        // Remove from promokits array
        const index = this.promokits.indexOf(identifier);
        if (index !== -1) {
            this.promokits.splice(index, 1);
        }

        this.update({ type: 'removePromokit', promokit_identifier: identifier });
    }

    // Save the lists to cookies
    save() {
        const latest_promokits_cookie_data = JSON.stringify(this.latest_promokits);
        const promokits_cookie_data = JSON.stringify(this.promokits);

        Cookies.set(this.defaults.cookie_latest_promokits, latest_promokits_cookie_data, this.defaults.cookie_options);
        Cookies.set(this.defaults.cookie_promokits, promokits_cookie_data, this.defaults.cookie_options);
    }

    update(update_type) {
        this.length = this.promokits.length;
        this.remainder = this.length - this.defaults.latest_promokits_limit;

        if (this.remainder < 0) {
            this.remainder = 0;
        }

        this.maintainBounds();

        if (update_type.type !== 'init') {
            this.save();
        }

        this.onUpdateCallback(update_type);
    }

    onUpdate(callback) {
        this.updateCallbacks.push(callback);
    }

    onAddPromokit(callback) {
        this.addPromokitCallbacks.push(callback);
    }

    onRemovePromokit(callback) {
        this.removePromokitCallbacks.push(callback);
    }

    onUpdateCallback(update) {
        if (update.type === 'removePromokit') {
            this.removePromokitCallbacks.forEach((callback) => callback(update.promokit_identifier));
        } else if (update.type === 'addPromokit') {
            this.addPromokitCallbacks.forEach((callback) => callback({ promokit: update.promokit, promokit_identifier: update.promokit_identifier }));
        }

        this.updateCallbacks.forEach((callback) => callback(update));
    }

    count(object) {
        return Object.keys(object).length;
    }

    decodeHTMLEntities(str) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = str;
        return textarea.value;
    }
}

export default new ContactList();
